export default {"src":"/_next/static/media/pcb.c8ab5463.svg","height":45,"width":43};